import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'ingredientsPipe'
})
export class IngredientsSelectPipe implements PipeTransform {
    transform(ingredients: any, term?: any): any {

        if( term === undefined) return ingredients;
        if( term === null) return ingredients;

        if(ingredients != null){
            return ingredients.filter(function(ingredient){
                if (ingredient.name != undefined)
                    if (ingredient.name.toLowerCase().includes(term.toLowerCase()))
                        return ingredient;
                    else if(ingredient.tags_static != undefined)
                        if(ingredient.tags_static.toLowerCase().includes(term.toLowerCase()))
                            return ingredient;

            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/pipes/ingredients-select-pipe.ts